// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ck-2";
export var aiChatCartContainerExit = "_ck-4";
export var aiChatContainerLarge = "_ck-0";
export var aiChatContainerSmall = "_ck-1";
export var aiChatIcon = "_ck-6";
export var slideInFromRight = "_ck-3";
export var slideOutToRight = "_ck-5";